import path from 'node:path'
import { applyAdminNamespaceToContent } from '@next-adapter/config/namespace/apply-admin-namespace-to-content.js'
import { applyAdminNamespaceToPath } from '@next-adapter/config/namespace/apply-admin-namespace-to-path.js'
import fs from 'fs-extra'

export function copyStaticComponentTemplatesRecursive(
  srcDir: string,
  destDir: string,
  relBase: string,
  createdPrefix: string,
  namespace: string,
  created: string[]
): void {
  const entries = fs.readdirSync(srcDir, { withFileTypes: true })
  for (const entry of entries) {
    const rel = path.join(relBase, entry.name)
    const srcPath = path.join(srcDir, entry.name)
    const destPath = path.join(destDir, entry.name)

    if (entry.isDirectory()) {
      const namespacedDestPath = path.join(
        destDir,
        applyAdminNamespaceToPath(entry.name, namespace)
      )
      copyStaticComponentTemplatesRecursive(
        srcPath,
        namespacedDestPath,
        rel,
        createdPrefix,
        namespace,
        created
      )
      continue
    }

    if (!entry.name.endsWith('.tsx') && !entry.name.endsWith('.ts')) {
      continue
    }

    const namespacedRel = applyAdminNamespaceToPath(rel, namespace)
    const namespacedDestPath = path.join(
      path.dirname(destPath),
      applyAdminNamespaceToPath(entry.name, namespace)
    )
    if (!fs.existsSync(namespacedDestPath)) {
      fs.ensureDirSync(path.dirname(namespacedDestPath))
      const content = fs.readFileSync(srcPath, 'utf-8')
      fs.writeFileSync(
        namespacedDestPath,
        applyAdminNamespaceToContent(content, namespace),
        'utf-8'
      )
      created.push(path.join(createdPrefix, namespacedRel))
    }
  }
}
